import { jsx as _jsx } from "react/jsx-runtime";
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import deepmerge from 'deepmerge';
import { Provider, useDispatch, useSelector, useStore } from 'react-redux';
import PersistState from './persist-state';
import page, { pageInitialState } from './slices/page';
import popup, { popupInitialState } from './slices/popup';
import site, { siteInitialState } from './slices/site';
import status, { statusInitialState } from './slices/status';
import widget, { widgetInitialState } from './slices/widget';
import { useDeepEqualSelector } from '../utils/use-deep-equal-selector';
export const persistKey = 'jaenjs-state';
const { loadState, persistState, persistMiddleware } = PersistState(persistKey);
const combinedReducer = combineReducers({
    site,
    page,
    status,
    popup,
    widget
});
const rootReducer = (state, action) => {
    if (action.type === 'RESET_STATE') {
        const payload = action.payload || {};
        return {
            site: deepmerge(siteInitialState, payload.site || {}),
            page: deepmerge(pageInitialState, payload.page || {}),
            status: statusInitialState,
            popup: deepmerge(popupInitialState, payload.popup || {}),
            widget: deepmerge(widgetInitialState, payload.widget || {})
        };
    }
    return combinedReducer(state, action);
};
const persistedState = loadState();
export const store = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        thunk: { extraArgument: {} }
    }).concat([...persistMiddleware]),
    devTools: true || process.env.NODE_ENV !== 'production',
    preloadedState: persistedState
});
export const { resetState } = persistState(store);
export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;
export const useAppDeepEqualSelector = useDeepEqualSelector;
export const useAppState = () => useStore().getState();
export const withRedux = (Component) => props => {
    return (_jsx(Provider, { store: store, children: _jsx(Component, { ...props }) }));
};
